import type { StrategyNode } from './BaseNode';

export function isStrategyNode(obj: any): obj is StrategyNode {
  return obj && typeof obj.clone === 'function';
}
